import { type CsticUpdate } from "~/Configurators/Linear/api/sendLinearConfiguratorUpdate";

/**
 * Generate an unique name to use in the LinearSubstep::additionalValidations map for validations
 *
 * @param update - type of kmat, index of kmat, name of cstic
 */
export const getExtraValidationParamName = (update: Pick<CsticUpdate, "type" | "index" | "key">) => {
  return `${EXTRA_VALIDATION_PARAM_PREFIX}-${update.type}-${update.index}-${update.key}`;
};
/**
 * Generate an unique name to use in the LinearSubstep::additionalData map
 *
 * @param update - type of kmat, index of kmat, name of cstic
 */
export const getDirtyParamName = (update: Pick<CsticUpdate, "type" | "index" | "key">) => {
  return `${EXTRA_DATA_DIRTY_PARAM_PREFIX}-${update.type}-${update.index}-${update.key}`;
};
export const EXTRA_DATA_DIRTY_PARAM_PREFIX = "isDirty";
export const EXTRA_VALIDATION_PARAM_PREFIX = "validity";
